module.exports = __webpack_public_path__ + "assets/img/churn-discount-offer.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/churn-discount-offer.svg
// module id = 564
// module chunks = 0